import { render } from "./BagicTable.vue?vue&type=template&id=662974ec&scoped=true"
import script from "./BagicTable.vue?vue&type=script&lang=js"
export * from "./BagicTable.vue?vue&type=script&lang=js"

import "./BagicTable.vue?vue&type=style&index=0&id=662974ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662974ec"]])

export default __exports__